import { gql } from '@apollo/client';

export const BUSINESS_DETAIL_FIELDS_FRAGMENT = gql`
  fragment BusinessDetailFields on BusinessDetail {
    simplrCategories
    simplrAccountId
    decisionTree
    partnerInfo
    tagsConfig
    flowDebugStateFavoriteFieldsList
  }
`;
